<select id="customSelect" class="form-control custom-select" (change)="onChange($event.target)">
  <ng-container *ngFor="let item of items">
    <option [value]="item" [selected]="item == currentItem">
      {{ item }}
    </option>
  </ng-container>
</select>
